import React from "react";
import { Tile, fmtDate } from "./primitives";

export default function WaitlistPanel({ waitlist }) {
  const count = waitlist?.count ?? 0;
  const items = waitlist?.waitlist || [];
  return (
    <Tile title={`Ebook waitlist (${count})`} testid="tile-waitlist">
      {count === 0 ? (
        <div className="text-xs text-[#5C6B62]">
          No one on the waitlist yet. Share the ebook page to build it.
        </div>
      ) : (
        <div className="space-y-1 max-h-56 overflow-y-auto">
          {items.slice(0, 30).map((w) => (
            <div
              key={w.email}
              className="text-[11px] flex justify-between gap-2 border-b border-[#F0EFEA] pb-1 last:border-0"
            >
              <span className="text-[#1C2B23] truncate">{w.email}</span>
              <span className="text-[#5C6B62]">{fmtDate(w.created_at)}</span>
            </div>
          ))}
          {count > 30 && (
            <div className="text-[11px] text-[#5C6B62] pt-1">+{count - 30} more…</div>
          )}
        </div>
      )}
    </Tile>
  );
}
